import PropTypes from "prop-types";
import { createContext, useEffect, useState } from "react";
import { useAlert } from "react-alert";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useLazyQuery } from "@apollo/client";
import CreateWorkspaceModal from "../../components/Administration/Sites/NewWorkspaceModal"
import EditWorkspaceModal from "../../components/Administration/Sites/EditSiteModal/index.jsx"
import {
  LIST_WORKSPACE_OWNER_CANDIDATES,
  LIST_WORKSPACE_TEMPLATE_CANDIDATES,
} from "../../graphql/queries/CompanyAdminContext";
import { getCurrentUser } from "../../helpers/selectors";
import {
  useGetNetworkSelectorItems,
  useListWorkspaceOrderGroupCandidates,
} from "../../hooks";
import {
  doNothing,
  haveCanManageWorkspacesRight,
  initialState,
  modalType,
} from "./helper";

export const workspaceAdminContext = createContext();

const { Provider } = workspaceAdminContext;

const WorkspaceAdminProvider = ({ children }) => {
  const alert = useAlert();
  const intl = useIntl();

  const { companyId, networkId: usersNetworkId, companyRole } = useSelector(getCurrentUser);

  //TODO: Det h�r �r nog fel. Kolla p� rollen p� det valda f�retaget r�ttigheter ist�llet
  const canManageWorkspaces = haveCanManageWorkspacesRight(companyRole);

  const [state, setState] = useState(initialState);

  const [haveNetworkSelectorItems, setHaveNetworkSelectorItems] = useState(false);
  const [haveWorkspaceOrderGroupCandidates, setHaveWorkspaceOrderGroupCandidates] = useState(false);
  const [haveWorkspaceOwnerCandidates, setHaveWorkspaceOwnerCandidates] = useState(false);
  const [haveWorkspaceTemplateCandidates, setHaveWorkspaceTemplateCandidates] = useState(false);

  const [networkSelectorItems, setNetworkSelectorItems] = useState();
  const [workspaceOrderGroupCandidates, setWorkspaceOrderGroupCandidates] = useState();
  const [workspaceOwnerCandidates, setWorkspaceOwnerCandidates] = useState();
  const [workspaceTemplateCandidates, setWorkspaceTemplateCandidates] = useState();

  const { getNetworkSelectorItems, data: networkSelectorItemsData, error: networkSelectorItemsError } = useGetNetworkSelectorItems();
  const { execute: listWorkspaceOrderGroupCandidates, data: workspaceOrderGroupCandidatesData, error: workspaceOrderGroupCandidatesError } = useListWorkspaceOrderGroupCandidates();
  const [listWorkspaceOwnerCandidates, { data: workspaceOwnerCandidatesData, error: workspaceOwnerCandidatesError }] = useLazyQuery(LIST_WORKSPACE_OWNER_CANDIDATES);
  const [listWorkspaceTemplateCandidates, { data: workspaceTemplateCandidatesData, error: workspaceTemplateCandidatesError }] = useLazyQuery(LIST_WORKSPACE_TEMPLATE_CANDIDATES);



  const closeModal = () => {
    setState((prev) => ({
      ...initialState,
    }));
  };

  const openCreateModal = () => {
    if (canManageWorkspaces) {
      setState((prev) => ({
        ...initialState,
        activeModal: modalType.CREATE_MODAL,
      }));

      setHaveNetworkSelectorItems(false);
      setHaveWorkspaceOrderGroupCandidates(false);
      setHaveWorkspaceOwnerCandidates(false);
      setHaveWorkspaceTemplateCandidates(false);
    }
  };



  useEffect(() => {
    if (state.activeModal !== modalType.NONE) {
      if (!state.dataReady) {
        listWorkspaceOwnerCandidates({ variables: { companyId } });
        listWorkspaceTemplateCandidates({ variables: { companyId } });
        listWorkspaceOrderGroupCandidates();
        getNetworkSelectorItems({ companyId });
        setState((prev) => ({
          ...prev,
          haveErrors: false,
        }));
      }
    }
  }, [state.activeModal, state.dataReady]);

  useEffect(() => {
    if (state.haveErrors) {
      alert.error(intl.formatMessage({ id: "common.genericErrorMessage" }));
      closeModal();
    }
  }, [state.haveErrors]);

  useEffect(() => {
    const newDataReady =
      !state.haveErrors &&
      haveNetworkSelectorItems &&
      haveWorkspaceOrderGroupCandidates &&
      haveWorkspaceOwnerCandidates &&
      haveWorkspaceTemplateCandidates;

    setState((prev) => {
      if (newDataReady === prev.dataReady) {
        return prev;
      }

      return ({
        ...prev,
        dataReady: newDataReady,
      });
    });
  },
    [
      state.haveErrors,
      haveNetworkSelectorItems,
      haveWorkspaceOrderGroupCandidates,
      haveWorkspaceOwnerCandidates,
      haveWorkspaceTemplateCandidates,
    ]
  );

  useEffect(() => {
    const errorFound =
      networkSelectorItemsError ||
      workspaceOrderGroupCandidatesError ||
      workspaceOwnerCandidatesError ||
      workspaceTemplateCandidatesError;

    if (errorFound) {
      setState((prev) => ({
        ...prev,
        haveErrors: true,
      }));
    }
  },
    [
      networkSelectorItemsError,
      workspaceOrderGroupCandidatesError,
      workspaceOwnerCandidatesError,
      workspaceTemplateCandidatesError,
    ]
  );



  useEffect(() => {
    var items = networkSelectorItemsData?.companyAdminContext?.businessNetworks?.networkSelectorItems;
    if (items) {
      setNetworkSelectorItems(items);
      setHaveNetworkSelectorItems(true);
    }
  }, [networkSelectorItemsData]);

  useEffect(() => {
    var data = workspaceOrderGroupCandidatesData?.companyAdminContext?.companyWorkspaces?.listWorkspaceOrderGroupCandidates;
    if (data) {
      const { items, success } = data;
      setWorkspaceOrderGroupCandidates(success ? items : undefined);
      setHaveWorkspaceOrderGroupCandidates(success);
      if (!success) {
        setState((prev) => ({
          ...prev,
          haveErrors: true,
        }));
      }
    }
  }, [workspaceOrderGroupCandidatesData]);

  useEffect(() => {
    var data = workspaceOwnerCandidatesData?.companyAdminContext?.companyWorkspaces?.listWorkspaceOwnerCandidates;
    if (data) {
      const { items, success } = data;
      setWorkspaceOwnerCandidates(success ? items : undefined);
      setHaveWorkspaceOwnerCandidates(success);
      if (!success) {
        setState((prev) => ({
          ...prev,
          haveErrors: true,
        }));
      }
    }
  }, [workspaceOwnerCandidatesData]);

  useEffect(() => {
    var data = workspaceTemplateCandidatesData?.companyAdminContext?.companyWorkspaces?.listWorkspaceTemplates;
    if (data) {
      const { items, success } = data;
      setWorkspaceTemplateCandidates(success ? items : undefined);
      setHaveWorkspaceTemplateCandidates(success);
      if (!success) {
        setState((prev) => ({
          ...prev,
          haveErrors: true,
        }));
      }
    }
  }, [workspaceTemplateCandidatesData]);


  const user = useSelector(state => state.api.currentViewer.viewer.username);

  const shouldUseWizard = ["devops@kommunal.se",
    "anders.henriksson@kommunal.se",
    "jonas.eckhardt@kommunal.se",
    "burt.vonbolton@kommunal.se",
    "admin.uniqueue@uniqueue.se",
    "admin@uniqueue.se"].includes(user);
  

  return (
    <>
      {state.activeModal === modalType.CREATE_MODAL && state.dataReady && (
        <CreateWorkspaceModal
          companyId={companyId}
          handleClose={closeModal}
          networkSelectorItems={networkSelectorItems}
          open={true}
          refresh={doNothing}
          usersNetworkId={usersNetworkId}
          workspaceOrderGroupCandidates={workspaceOrderGroupCandidates}
          workspaceOwnerCandidates={workspaceOwnerCandidates}
          workspaceTemplateCandidates={workspaceTemplateCandidates}
          useWizard={shouldUseWizard}
        />
      )}
      {state.activeModal === modalType.EDIT_MODAL && state.dataReady && (
        <div>EDIT MODAL</div>
        //<EditSiteModal
        //  open={activeModal === modalType.EDIT_MODAL}
        //  companyId={companyId}
        //  siteId={selectedSiteId}
        //  networkSelectorItems={networkSelectorItems}
        //  workspaceOwnerCandidates={workspaceOwnerCandidates}
        //  workspaceOrderGroupCandidates={workspaceOrderGroupCandidates}
        //  handleClose={closeModal}
        //  refresh={doNothing}
        ///>
      )}
      <Provider value={{ canManageWorkspaces, openCreateModal, /*openEditModal,*/ }}>
        {children}
      </Provider>
    </>
  );
};

WorkspaceAdminProvider.propsType = {
  children: PropTypes.node.isRequired,
};

export default WorkspaceAdminProvider;
